module.exports = __webpack_public_path__ + "static/img/ct4.c5035ec.jpg";